import { Category } from "./category";
import {TeamRaceType} from "./team-race-type";
import {TeamType} from "./team-type";

export class RaceSettings {
  raceId?: number;
  applicationProcedure?: number;
  typeOfApplication?: number;
  teamType?: number;
  selectionOfTeamMembersType?: number;
  teamNameRequired?: boolean;
  genderRequired?: boolean;
  measurementType?: number;
  measurementPrecisionType?: number;
  startByType?: StartByTypeTypes;
  resultsPerPage?: number;
  topRanked?: number;
  teamParticipantsForRanking?: number;
  teamRankingGenderSeparation?: number;
  rankingGroups?: string;
  participantsFromRankingGroup?: number;
  groupRankingSeparation?: number;
  teamRankingTeamSeparation?: number;
  penaltyMinutes?: number;
  controlPoints?: number;
  resultProcessingType?: ResultProcessingType;
  minimumLapDuration?: string;
  lapLength?: number;
  jaguarNumberShift?: number;
  resultDisplayType?: ResultDisplayType;
  rotatingResultsSeconds?: number;
  registrationExternalUrl?: string;
  category?: Category;
  blockStart?: boolean;
  maxParticipantsInStartBlock?: number;
  enableGroupRegistrationPayment?: boolean;
  maxGroupRegisteredParticipants?: number;
  useGroupRanking?: boolean;
  timingSystem?: number;
  timingEquipment?: number;
  usingUploadRoute?: boolean;
  displayControlPoints?: boolean;
  showRouteProfile?: boolean;
  enableGPXDownload?: boolean;
  usingDistanceMarkersOnRoute?: boolean;
  distanceMarkersOnRoute?: number[];
  maxLapsCount?: number;
  teamRaceType?: TeamRaceType;

  static hasMinimumLapDuration = (minimumLapDuration: string|undefined): boolean =>
      minimumLapDuration !== undefined && minimumLapDuration !== null && minimumLapDuration !== "0";

  static isRoundRace = (resultProcessingType: ResultProcessingType | undefined): boolean =>
      (ResultProcessingType.ROUND_RACE === resultProcessingType
          || ResultProcessingType.BACKYARD_ULTRA === resultProcessingType
          || ResultProcessingType.TIME_LIMITED === resultProcessingType);

  static isBlockRace = (blockStart: boolean|undefined): boolean =>
    blockStart ?? false;

  static isStartByGenderRace = (startByType: number|undefined): boolean =>
    startByType === StartByTypeTypes.SEPARATE_BY_GENDER;

  static isTeamRace = (raceSettings: RaceSettings|undefined): boolean => {
    if (!raceSettings || raceSettings.teamType === undefined || raceSettings.teamType === null) {
      return false;
    }
    return raceSettings.teamType !== TeamType.SINGLE && raceSettings.teamType !== TeamType.TEAM_NO_MEMBERS_NEEDED;
  };

  static isConcurrentRace = (raceSettings: RaceSettings|undefined): boolean =>
      RaceSettings.isTeamRace(raceSettings) && raceSettings?.teamRaceType === TeamRaceType.CONCURRENT;

}

export enum TimingSystem {
  ELECTRONIC = 1,
  PLATFORM = 2,
  EXTERNAL = 3
}

export enum ResultProcessingType {
  DISTANCE_DEFINED = 1,
  ROUND_RACE = 2,
  BACKYARD_ULTRA = 3,
  TIME_LIMITED = 4,
}

export enum ResultDisplayType {
  STANDARD = 1,
  ROTATING = 2,
  ROAD_CYCLING = 3
}


export enum ApplicationProcedureTypes {
  STANDARD = 0,
  CYCLING = 1,
  TRIATHLON = 2,
  STAGE_RACE = 3
}

export enum TypeOfApplicationTypes {
    REGISTRATION_LIST = 0,
    START_LIST= 1,
    DO_NOT_DISPLAY_PARTICIPANT_LIST = 2,
}

export enum GenderSeparationTypes {
  NOT_USED = 0,
  TOGETHER_NO_GENDER_DIFFERENCE = 1,
  SEPARATE_BY_GENDER = 2
}

export enum MeasurementTypes {
  GUN_TIME_ONLY = 0,
  CHIP_TIME_ONLY = 1,
  GUN_TIME_PRIMARY = 2,
  CHIP_TIME_PRIMARY = 3,
  EXTERNAL_IMPORT = 4,
}

export enum MeasurementPrecisionTypes {
  SECONDS = 0,
  TENTHS = 1,
  HUNDREDTHS = 2,
  THOUSANDTHS = 3,
}

export enum StartByTypeTypes {
  ALL = 1,
  SEPARATE_BY_GENDER = 2,
}

export enum DistanceMarkers {
  ZeroOneKm = 1,
  ZeroFiveKm = 2,
  OneKm = 3,
  TwoKm = 4,
  FiveKm = 5,
  TenKm = 6,
  TwentyKm = 7,
  TwentyFiveKm = 8
}

export enum TeamRankingTeamSeparationTypes {
  NOT_USED = 0,
  GROUP_ONLY = 1,
  TEAM_AND_GROUP = 2
}

export enum PenaltyMinutesTypes {
  NOT_VISIBLE = 0,
  VISIBLE_TO_PUBLIC = 1,
  VISIBLE_TO_ADMINISTRATION = 2,
  ALWAYS_VISIBLE = 3
}

export enum TimingEquipments {
  MACSHA = 1,
  JAGUAR = 2,
  MY_LAPS = 3,
  RACE_RESULTS = 4,
  OTHER = 5
}

export enum RotatingOrderTypes {
  ABSOLUTE_ORDER = 0,
  MEN_FIRST_WOMEN_SECOND = 1,
  WOMEN_FIRST_MEN_SECOND = 2,
}
